function AppContent(p){
    return(<section className="content">{p.children}</section>);
}

export default AppContent;